import { biliBridge, initEnv } from "@bilibili/js-bridge";

initEnv();

/**
 * 切换展示webview 导航栏
 * @param show [boolean=false]
 * @description 默认隐藏
 */
export function toggleNav(show: boolean = false) {
  const method = show ? "ui.showNavigation" : "ui.hideNavigation";

  biliBridge.callNative({
    method
  });
}

/**
 * 关闭当前webview窗口
 */
export function closeBrowser() {
  biliBridge.callNative({
    method: "global.closeBrowser"
  });
}

/**
 * 去掉bounce
 */
export function closeScrollBounces() {
  biliBridge.callNative({
    method: "ui.setScrollBounces",
    data: {
      bounces: false
    }
  });
}
